export let ElementStatus = /*#__PURE__*/function (ElementStatus) {
  ElementStatus["GeneratedAll"] = "generatedAll";
  ElementStatus["Generated"] = "generated";
  ElementStatus["Passed"] = "passed";
  ElementStatus["Failed"] = "failed";
  ElementStatus["Warning"] = "warning";
  ElementStatus["Loading"] = "loading";
  ElementStatus["ManualFailed"] = "manualFailed";
  ElementStatus["ManualPassed"] = "manualPassed";
  return ElementStatus;
}({});
//# sourceMappingURL=types.js.map